export const APP = {
    loggedin: true

}